import { berthApiClient } from '../berthApiClient'

import { updateSpecificInfoEndpoint } from './endpoint'
import type { UpdateSpecificInfoParams, UpdateSpecificInfoResponse } from './type'

export const updateSpecificInfo = async (
  params: UpdateSpecificInfoParams
): Promise<UpdateSpecificInfoResponse> => {
  const res = await berthApiClient.put<UpdateSpecificInfoResponse>(
    updateSpecificInfoEndpoint,
    params
  )
  return res.data
}
